import type { OrderItem } from "@/models/OrderItem";

export default class CartCalculator {
  static calculateTotal(items: OrderItem[]): number {
    return items.reduce((sum, item) => sum + item.price * item.quantity, 0);
  }
}
